import { cache } from 'react';

import { get } from '@monoimin/storyblok/get';

import { STORYBLOK_TOKENS } from '@monoimin/constants';

import type { DataSourceEntry } from '@monoimin/sb-types';

/**
 * @type { RegionName: CountryCode[] }
 */
type Regions = Record<string, string[]>;

const fetchRegionsCountriesData = cache(async () => {
  try {
    const {
      data: { datasource_entries },
    } = await get<{ data: { datasource_entries: DataSourceEntry[] } }>(
      'cdn/datasource_entries',
      {
        datasource: 'project-passport-ratings-constants',
        version: 'published',
        token: STORYBLOK_TOKENS.client.api,
      }
    );

    const regionsCountriesEntry = datasource_entries.find(
      (e) => e.name === 'REGIONS_COUNTRIES'
    );

    if (regionsCountriesEntry) {
      return JSON.parse(regionsCountriesEntry.value) as Regions;
    }

    return null;
  } catch (error) {
    console.error('Failed to fetch regions data:', error);
    return null;
  }
});

export const getAnalyticsRegionList = async (
  itemCountryField: string[] | string | number | (string | number)[] | undefined
) => {
  if (!itemCountryField) {
    return '';
  }

  const itemCountries = Array.isArray(itemCountryField)
    ? itemCountryField
    : [String(itemCountryField)];

  const regionsData = await fetchRegionsCountriesData();

  if (!regionsData) {
    return '';
  }

  const regionsEntries = Object.entries(regionsData);
  const pageRegions = Array.from(
    itemCountries.reduce((acc, countryCode) => {
      const regionEntry = regionsEntries.find(([, countries]) =>
        countries.includes(String(countryCode))
      );
      const regionName = regionEntry ? regionEntry[0] : undefined;
      return regionName ? acc.add(regionName) : acc;
    }, new Set<string>())
  );

  return pageRegions;
};
